<div class="br-host" #host></div>

<!-- Header bar: keep the clock + blinds visible during the reveal, the same way
the seat-draw / table-break overlays do. -->
<div class="br-header">
  <div class="br-header-name">{{ tournServ.latestTourn?.tournName }}</div>
  <div class="br-header-clock">
    <span class="br-time">{{ tournServ.clock?.time }}</span>
    @if (tournServ.clock?.levelName) {
      <span class="br-level">{{ tournServ.clock.levelName }}</span>
    }
    <span class="br-blinds">
      {{ tournServ.clock?.sb }} / {{ tournServ.clock?.bb }}
    </span>
    @if (tournServ.clock?.ante) {
      <span class="br-ante"
        >{{ "ANTE" | translate }}: {{ tournServ.clock.ante }}</span
      >
    }
  </div>
</div>

<!-- Portrait (mobile): "Bounty Draw" title under the header. -->
<div class="br-title-mobile">{{ "BOUNTY_DRAW_TITLE" | translate }}</div>

<!-- Landscape (fullscreen clock): players panel beside the lottery box — the
winner's avatar + name, and the eliminated player's avatar (greyscale + X). -->
<div class="br-players">
  <div class="br-players-title">{{ "BOUNTY_DRAW_TITLE" | translate }}</div>
  <div class="br-player">
    <div class="br-avatar-wrap">
      <img class="br-avatar" [src]="killerImage" alt="" />
    </div>
    @if (killerName) {
      <div class="br-player-name">{{ killerName }}</div>
    }
  </div>

  <div class="br-connector">↓</div>

  <div class="br-player br-player--out">
    <div class="br-avatar-wrap">
      <img class="br-avatar br-avatar--out" [src]="eliminatedImage" alt="" />
      <span class="br-x-badge">✕</span>
    </div>
    @if (eliminatedName) {
      <div class="br-player-name br-player-name--out">{{ eliminatedName }}</div>
    }
  </div>

  <!-- Always rendered (reserves its space) and only toggled visible on reveal,
  so the centered panel doesn't jump when the winner line appears. -->
  <div class="br-won br-won--panel" [class.br-invisible]="!revealed()">
    {{ "BOUNTY_WIN" | translate: { killer: killerName, value: curValue() } }}
  </div>
</div>

<!-- Landscape multi-draw: a running list of awarded bounties on the right —
each winner's avatar + name and the ball value drawn. -->
@if (isSequence) {
  <div class="br-awarded">
    @for (a of awarded(); track $index) {
      <div class="br-awarded-row">
        <div class="br-awarded-player">
          <img class="br-awarded-avatar" [src]="imageFor(a.killerID)" alt="" />
          <div class="br-awarded-name">{{ nameFor(a.killerID) }}</div>
        </div>
        <div class="br-awarded-ball">{{ a.value }}</div>
      </div>
    }
  </div>
}

<!-- Portrait (mobile): winner + eliminated avatars in a horizontal row at the
bottom, plus the winner line on reveal. -->
<div class="br-caption">
  <div class="br-caption-players">
    <div class="br-player br-player--mobile">
      <div class="br-avatar-wrap">
        <img class="br-avatar" [src]="killerImage" alt="" />
      </div>
      @if (killerName) {
        <div class="br-player-name">{{ killerName }}</div>
      }
    </div>

    <div class="br-player br-player--mobile br-player--out">
      <div class="br-avatar-wrap">
        <img class="br-avatar br-avatar--out" [src]="eliminatedImage" alt="" />
        <span class="br-x-badge">✕</span>
      </div>
      @if (eliminatedName) {
        <div class="br-player-name br-player-name--out">{{ eliminatedName }}</div>
      }
    </div>
  </div>

  <div class="br-won" [class.br-invisible]="!revealed()">
    {{ "BOUNTY_WIN" | translate: { killer: killerName, value: curValue() } }}
  </div>
</div>

<!-- Landscape: remaining (undrawn) bounty balls along the bottom, biggest
first — centered while they fit, small tail clips off the right edge. Balls
drop out as they're revealed on screen. -->
@if (remainingValues.length) {
  <div class="br-remaining">
    <div class="br-remaining-row">
      @for (v of remainingValues; track $index) {
        <div class="br-remaining-ball">{{ v }}</div>
      }
    </div>
  </div>
}

@if (failed()) {
  <div class="br-fallback">
    <div class="br-fallback-value">{{ curValue() }}</div>
    @if (killerName) {
      <div class="br-won">
        {{ "BOUNTY_WIN" | translate: { killer: killerName, value: curValue() } }}
      </div>
    }
  </div>
}
